import React from 'react'
import { useSelector } from 'react-redux'

import type { CheckboxListFilterProps } from '~/components/common/filters/CheckboxListFilter'
import { getInventoriesListFilters } from '~/store/reducers/inventories'

import CategoryFilter from '../filters/CategoryFilter'

export interface InventoryTableCategoryFilterProps
  extends CheckboxListFilterProps {}

const InventoryTableCategoryFilter = (
  props: InventoryTableCategoryFilterProps,
) => {
  const inventoryFilters = useSelector(getInventoriesListFilters)

  return (
    <CategoryFilter
      selectedCategoryFilter={inventoryFilters?.categoryIds}
      {...props}
    />
  )
}

export default InventoryTableCategoryFilter
